<template>
  <section class="podcast">
    <div class="container">
      <div class="title">
        <span>Podcast</span><span>Listen</span>
      </div>
      <div class="podcast-list">
        <a rel="noopener" v-for="(podcast, index) in podcasts" :key="index" :href="podcast.url" target="_blank">
          <div class="podcast-item">
            <div class="podcast-item__orange"></div>
            <div class="podcast-item__title">
              <span class="podcast-item__number-mobile">0{{ index + 1 }}</span>
              <span v-html="`${podcast.title}`"></span>
            </div>
            <div class="podcast-item__cover">
              <div
                class="cover-image"
                :style="{ 'background-color': podcast.color }"
                v-html="podcast.embed"
              ></div>
              <div class="cover-image__mask" v-if="scrolling"></div>
            </div>
            <div class="podcast-item__number" v-html="`0${index + 1}`"></div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import hades from '@/scripts/hades';
import aion from '@/scripts/aion';

export default {
  name: 'PodcastSection',

  data() {
    return {
      scrolling: false,
      podcasts: [
        {
          title: 'Descent into the neo-Nazi movement',
          cover: '',
          url: 'https://open.spotify.com/episode/3TOQs1mrkcZrFT8UaE2FWx?si=r7H7tusCSlOjkzuBeJHhfw',
          embed: '<iframe title="Podcast 1" src="https://open.spotify.com/embed-podcast/episode/3TOQs1mrkcZrFT8UaE2FWx" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
          color: '#A12B3F',
        }, {
          title: 'How to fight climate change',
          cover: '',
          url: 'https://open.spotify.com/episode/0iiZ0BdUvZUbNCgMglL6tm?si=B5UCGtR3SP6AhdJXSMmLUw',
          embed: '<iframe title="Podcast 2" src="https://open.spotify.com/embed-podcast/episode/0iiZ0BdUvZUbNCgMglL6tm" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
          color: '#401E57',
        }, {
          title: 'Being a Muslim in America',
          cover: '',
          url: 'https://open.spotify.com/episode/6Da7OUHrAwDaqzx3I3uNJs?si=Zul8diN4R86R9_g40wfgfg',
          embed: '<iframe title="Podcast 3" src="https://open.spotify.com/embed-podcast/episode/6Da7OUHrAwDaqzx3I3uNJs" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
          color: '#2B2E3B',
        }, {
          title: 'Deconstructing Racism',
          cover: '',
          url: 'https://open.spotify.com/episode/4c01NZ1FSST1iDi8imiUxg?si=DUdxEhlGSZKH9gh2oHMVNQ',
          embed: '<iframe title="Podcast 4" src="https://open.spotify.com/embed-podcast/episode/4c01NZ1FSST1iDi8imiUxg" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
          color: '#422428',
        }, {
          title: 'Why female entrepreneurs get less funding',
          cover: '',
          url: 'https://open.spotify.com/episode/4lAEhXPXrXHrQGFhyGGyIk?si=pi2fnnGOSqmTQGDz1sQTqg',
          embed: '<iframe title="Podcast 5" src="https://open.spotify.com/embed-podcast/episode/4lAEhXPXrXHrQGFhyGGyIk" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
          color: '#A4282E',
        }],
    };
  },

  mounted() {
    let prevAmount = 0;
    aion.add(() => {
      if (Math.round(hades.ref.amount.y) === prevAmount) this.scrolling = false;
      else this.scrolling = true;
      prevAmount = Math.round(hades.ref.amount.y);
    }, 'iframe-mask');
  },
};
</script>

<style lang="scss" scoped>
.podcast {
  .container {
    width: 100%;
    padding: 0px 100px;
    max-width: 1440px;
    margin: 0 auto;

    @include mq($until: ipadP) {
      padding: 0px 20px;
    }

    .title {
      font-family: 'GT America Expanded';
      font-size: rem(120px);
      margin-bottom: 60px;

      @include mq($until: ds) {
        font-size: rem(90px);
      }

      @include mq($until: ipadL) {
        font-size: rem(60px);
      }

      @include mq($until: ipadP) {
        font-size: rem(42px);
        margin-bottom: 30px;
      }

      span:nth-child(2) {
        -webkit-text-fill-color: transparent;
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: $color-primary;
      }
    }

    .podcast-item {
      position: relative;
      width: 100%;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: repeat(20, 1fr);
      justify-content: space-between;
      border-bottom: 1px solid $color-gray;
      padding: 20px 0px;

      @include mq($until: ds) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      @include mq($until: ipadP) {
        flex-direction: column;
      }

      &:first-child {
        border-top: 1px solid $color-gray;
      }

      &__orange {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: $color-primary;
        transform: scaleY(0);
        transform-origin: 50% 0px;
        transition: transform 0.6s cubic-bezier(.9, .25, .1, .75);
      }

      &:hover .podcast-item__orange {
        transform: scaleY(1);

        @include mq($and: $is-touch-device) {
          transform: scaleY(0);
        }
      }

      &__title {
        position: relative;
        font-size: rem(80px);
        line-height: rem(90px);
        grid-column-start: 1;
        grid-column-end: 11;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-right: 20px;

        span {
          position: relative;
          padding-left: 20px;

          &:nth-child(2) {
            @include mq($until: ipadL) {
              margin-top: 40px;
            }

            @include mq($until: ipadP) {
              margin-top: 20px;
            }
          }
        }

        span::before {
          position: absolute;
          left: 0px;
          top: 0px;
          line-height: rem(90px);

          @include mq($until: ds) {
            line-height: rem(90px);
          }

          @include mq($until: ipadL) {
            line-height: rem(50px);
          }

          @include mq($until: ipadP) {
            line-height: rem(70px);
          }
        }

        span:not(.podcast-item__number-mobile)::before {
          content: ".";
        }

        @include mq($until: ds) {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;

          font-size: rem(80px);
          line-height: rem(90px);
          order: 1;
        }

        @include mq($until: ipadL) {
          font-size: rem(40px);
          line-height: rem(50px);
        }

        @include mq($until: ipadP) {
          font-size: rem(60px);
          line-height: rem(70px);
          margin-bottom: 20px;
          width: 100%;
        }
      }

      &__number {
        position: relative;
        font-size: rem(200px);
        grid-column-start: 16;
        grid-column-end: 21;
        display: flex;
        justify-content: center;
        align-items: center;

        @include mq($until: ds) {
          font-size: rem(80px);
          display: none;
        }

        @include mq($until: ipadL) {
          font-size: rem(120px);
        }

        @include mq($until: ipadP) {
          font-size: rem(20px);
        }

        &-mobile {
          display: none;

          @include mq($until: ds) {
            display: inline-block;
          }
        }
      }

      &__cover {
        position: relative;
        grid-column-start: 11;
        grid-column-end: 16;

        @include mq($until: ds) {
          order: 3;
        }

        .cover-image {
          margin: 20px auto;
          width: 300px;
          height: 300px;
          background-size: cover;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cover-image__mask {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
